import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '../../constants';
import { setAuthorizedEvent } from '../../App';

export const updateTokens = async (access_token, refresh_token, isAuthorized = true) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
  localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
  setAuthorizedEvent(isAuthorized);
};
